import React from 'react';
import { Award, Package, Clock, Users } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Award,
      title: 'Quality Assured',
      description: 'Genuine and certified aftermarket parts from trusted manufacturers'
    },
    {
      icon: Package,
      title: 'Wide Inventory',
      description: 'Extensive stock of parts for all major heavy machinery brands'
    },
    {
      icon: Clock,
      title: 'Fast Delivery',
      description: 'Quick turnaround time to keep your operations running smoothly'
    },
    {
      icon: Users,
      title: 'Expert Support',
      description: 'Knowledgeable team to help you find the right parts for your needs'
    }
  ];

  return (
    <section id="about" className="py-20 sm:py-28 bg-blue-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            About Falak al Madina
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            With years of experience in the heavy machinery parts industry, 
            Falak al Madina Auto Spare Parts has established itself as a reliable 
            supplier of quality components for construction equipment, commercial vehicles, 
            and industrial machinery. We pride ourselves on delivering excellence in both 
            product quality and customer service.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="group p-8 bg-slate-50 rounded-xl hover:bg-blue-50 transition-all duration-300 hover:shadow-lg border border-transparent hover:border-blue-200"
              >
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-5 group-hover:bg-blue-600 transition-colors duration-300">
                  <Icon className="text-blue-600 group-hover:text-white transition-colors duration-300" size={28} />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;